import { render, staticRenderFns } from "./AgentAvatar.vue?vue&type=template&id=4bf5534e&lang=pug&"
import script from "./AgentAvatar.vue?vue&type=script&lang=ts&"
export * from "./AgentAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
